import * as z from "zod";

export const getMasonhubIntegration = {
  name: "getMasonhubIntegration" as const,
  input: z.object({}),
  output: z.object({
    integration: z
      .object({
        accountSlug: z.string(),
        apiTokenPreview: z.string(),
        sandboxMode: z.boolean(),
        createReturns: z.boolean(),
      })
      .nullable(),
  }),
};
